import React from 'react'
import { useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { RootState } from '../../store/rootReducer'
import { MemberState, Payment } from '../../store/member/memberTypings'

import moment from 'moment-mini'
import paths from '../../paths'
import './paymentTable.sass'

interface Props {
    list: Payment[]
}

const PaymentTable: React.FunctionComponent<Props> = ({ list }: Props) => {
    const [t] = useTranslation()

    const { user } = useSelector<RootState, MemberState>((state) => state.member)

    const isPaymentGift = (item: Payment) => item.user_id === item.receiver_id

    return (
        <div className="paymentHistory">
            {user.expiration_date_ts > 0 ? (
                <p>
                    {t('Your Premium subscription is active till')}
                    <strong>{moment.unix(user.expiration_date_ts).format('DD/MM/YYYY')}</strong>
                </p>
            ) : (
                <></>
            )}
            <p className="tableHeader">{t('History')}</p>
            <div className="historyTable">
                <div className="line">
                    <p className="bold">{t('Purchase date')}</p>
                    <p className="bold hiddenOnMobile">{t('Ticket number')}</p>
                    <p className="bold">{t('Type')}</p>
                    <p className="bold">{t('Purpose')}</p>
                </div>
                {list.map((item) => {
                    return (
                        <div className="line" key={item.id}>
                            <p>{moment(item.date_time * 1000).format(t('time format'))}</p>
                            {!isPaymentGift(item) && item.receiver ? (
                                <div className={'ticketInfo'}>
                                    <Link
                                        to={
                                            item.receiver.nick
                                                ? paths.profile.toPath({
                                                      nick:
                                                          user.id === item.receiver.id
                                                              ? item.user.nick
                                                              : item.receiver.nick
                                                  })
                                                : paths.profiles.path
                                        }
                                    >
                                        <Trans
                                            i18nKey={user.id === item.receiver.id ? 'Given by' : 'Gift for'}
                                            values={{
                                                userNick:
                                                    user.id === item.receiver.id
                                                        ? item.user.nick
                                                        : item.receiver.nick || t('deleted')
                                            }}
                                        >
                                            {user.id === item.receiver.id ? 'Given by' : 'Gift for'}
                                            <span>{item.receiver.nick || t('deleted')}</span>
                                        </Trans>
                                    </Link>
                                    {item.message && (
                                        <div className={'paymentMessage'}>
                                            <p>{item.message}</p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <p className={'ticketInfo'}>{item.code}</p>
                            )}
                            <p>{item.type}</p>
                            <p>{item.purpose}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default PaymentTable
